<!-- 商品模块 -->
<template>
  <div class="template_carousel">
    <el-dialog
      title="编辑商品模块"
      :visible.sync="show"
      width="1700px"
      @close="closeFn"
      @closed="closedFn"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div>
        <el-form
          :model="form"
          label-width="150px"
          :inline="false"
          size="normal"
          :rules="rules"
          ref="newFormRef"
        >
          <el-form-item label="模块名称：" prop="name">
            <el-input v-model="form.name" size="mini" maxlength="20" placeholder="请输入模块名称，最多20字"></el-input>
          </el-form-item>
          <el-form-item label="选择商品：">
            <el-button type="primary" @click="openDialog">选择商品</el-button>
            <el-button type="danger" @click="batchDelete">批量删除</el-button>
            <el-table
              size="small"
              :data="multipleSelection"
              ref="tableRef"
              stripe
              border
              highlight-current-row
              style="max-width: 1550px;margin-top: 20px"
            >
              <el-table-column align="center" label width="180" type="selection"></el-table-column>
              <el-table-column align="center" label="id" width="180">
                <template slot-scope="scope">
                  <span>{{scope.row.id}}</span>
                </template>
              </el-table-column>
              <el-table-column width="330" align="center" label="商品标题">
                <template slot-scope="scope">
                  <span>{{scope.row.title}}</span>
                </template>
              </el-table-column>
              <el-table-column width="245" align="center" label="副标题">
                <template slot-scope="scope">
                  <span>{{scope.row.viceTitle}}</span>
                </template>
              </el-table-column>
              <el-table-column width="140" align="center" label="商品封面">
                <template slot-scope="scope">
                  <img :src="scope.row.cover" style="width:80px;height:80px;object-fit: cover" />
                </template>
              </el-table-column>
              <el-table-column width="100" align="center" label="出售价">
                <template slot-scope="scope">
                  <span>{{scope.row.price}}</span>
                </template>
              </el-table-column>
              <el-table-column width="100" align="center" label="市场价">
                <template slot-scope="scope">
                  <span>{{scope.row.maxPrice}}</span>
                </template>
              </el-table-column>
              <el-table-column label="排序" width="150" align="center">
                <template slot-scope="{ row }">
                  <div class="disFlx disFlxAIC">
                    <el-input-number
                      v-model="row.sort"
                      :controls="false"
                      :min="1"
                      size="mini"
                      class="mr-10"
                      placeholder="排序数字"
                      @blur="upGoodsList(row)"
                    ></el-input-number>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="{ row,$index }">
                  <el-button type="danger" size="mini" @click="removeGoodsList(row,$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <div class="tc">
          <el-button type="primary" size="default" @click="seve">确定</el-button>
          <el-button size="default" @click="closeFn">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 商品选择组件 -->
    <commodity
      :visible.sync="dlGoodsShow"
      :select-list.sync="dialogGoodsList"
      @on-select="onSelect"
      :limit="6"
    ></commodity>
  </div>
</template>

<script>
// import { getHttps } from "@/api/demo/classification/index";
import commodity from '../../../../components/commodity/shop.vue'

export default {
  components: {
    commodity // 商品选择组件
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    items: {
      type: Object,
      default: {}
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  watch: {
    show (val) {
      let that = this
      if (val) {
        that.form.name = that.items.name
        if (that.items.dataJson) {
          that.form = JSON.parse(JSON.stringify(that.items.dataJson))
          that.multipleSelection = JSON.parse(
            JSON.stringify(that.items.dataJson)
          ).dataList
        }
      }
    }
  },
  data () {
    return {
      // 七牛上传图片
      form: {
        name: '', // 模块名称
        type: 7,
        dataList: [],
        dataLitdis: [],
        goods: [], // 商品分类
        coupons: [] // 优惠券分类
      },
      rules: {
        name: [{ required: true, message: '请输入模块名称', trigger: 'blur' }]
      },

      multipleSelection: [], // 指定商品
      dlGoodsShow: false,
      dialogGoodsList: [] // 弹窗商品列表
    }
  },
  mounted () {
    let that = this
  },
  methods: {
    // 选择商品
    openDialog () {
      this.dlGoodsShow = true
      this.dialogGoodsList = this.multipleSelection // 勾选回选
    },
    // 修改商品排序
    async upGoodsList (row) {
      if (this.items.remodelAssemblyId) {
      }
    },
    // 商品弹窗确认选择
    async onSelect () {
      let newGoodsList = this.dialogGoodsList.filter(
        item => !this.multipleSelection.some(ele => ele.id === item.id)
      ) // 新数组
      newGoodsList.forEach(v => {
        this.$set(v, 'sort', 10)
      })
      if (this.items.remodelAssemblyId) {
        // 编辑时，直接调取修改商品接口
      } else {
        this.multipleSelection = [...this.multipleSelection, ...newGoodsList] // 商品
      }
    },
    // 商品批量删除
    async batchDelete () {
      console.log(
        'this.$refs.tableRef.selection',
        this.$refs.tableRef.selection
      )
      if (!this.$refs.tableRef.selection.length) {
        this.$message.error('请勾选要删除的商品')
        return
      }
      if (this.items.remodelAssemblyId) {
        // 编辑时，直接调取修改商品接口
      } else {
        for (var i = this.$refs.tableRef.selection.length - 1; i >= 0; i--) {
          this.multipleSelection.splice(i, 1)
        }
      }
    },
    // 确定按钮
    seve () {
      let that = this
      that.$refs.newFormRef.validate(valid => {
        // console.log("that.multipleSelection", that.multipleSelection);
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.items))
          params.name = this.form.name
          params.isHome = 1
          that.form.dataList = that.multipleSelection // 小程序需要用到的数据--模块(商品)数据
          params.dataJson = that.form
          params.remodelAssemblyGoodsAddVOList = that.multipleSelection // 商品
          // //商品
          params.goods = []
          for (let index = 0; index < that.multipleSelection.length; index++) {
            params.goods.push({
              spuId: that.multipleSelection[index].id,
              categoryIndex: 0,
              sort: that.multipleSelection[index].sort
            })
          }
          // end 商品
          this.$emit('dataListG', params)
        }
      })
    },
    // 删除商品
    async removeGoodsList (row, index) {
      if (this.items.remodelAssemblyId) {
        // 编辑时，直接调取修改商品接口
      } else {
        console.log('index0', index)
        this.multipleSelection.splice(index, 1)
      }
    },
    closeFn () {
      Object.assign(this.$data, this.$options.data())
      this.$emit('closeFn')
    },
    closedFn () {
      this.$refs.newFormRef.clearValidate()
    }
  },

  created () {
    let that = this
  }
}
</script>
<style lang='scss' scoped>
.tc {
  text-align: center;
}
.mb-20 {
  margin-bottom: 20px !important;
}
.red {
  color: red;
}
.blue {
  color: blue;
}
.black {
  color: black;
}
.green {
  color: green;
}
</style>
